import ElementPlus from "element-plus";
import "boxicons/css/boxicons.min.css";
import "@/styles/element/index.scss";
import "element-plus/theme-chalk/display.css";
import locale from "element-plus/lib/locale/lang/es";
import { App } from "vue";

export default {
  install: (app: App): void => {
    app.use(ElementPlus, { locale, size: "mini", zIndex: 3000 });
  },
};
